import * as React from "react";
import { theme } from "../../../theme";

interface Props {
  color?: string;
}

export const GridIcon: React.FC<Props> = ({ color = theme.colors.text }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.59257 6.44196C2.92887 6.66667 3.39703 6.66667 4.33333 6.66667C5.26965 6.66667 5.7378 6.66667 6.0741 6.44196C6.21969 6.34468 6.34469 6.21968 6.44196 6.07409C6.66667 5.73779 6.66667 5.26964 6.66667 4.33333C6.66667 3.39703 6.66667 2.92887 6.44196 2.59257C6.34469 2.44699 6.21969 2.32199 6.0741 2.22471C5.7378 2 5.26965 2 4.33333 2C3.39703 2 2.92887 2 2.59257 2.22471C2.44699 2.32199 2.32199 2.44699 2.22471 2.59257C2 2.92887 2 3.39703 2 4.33333C2 5.26964 2 5.73779 2.22471 6.07409C2.32199 6.21968 2.44699 6.34468 2.59257 6.44196Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M9.92456 6.44196C10.2609 6.66667 10.729 6.66667 11.6654 6.66667C12.6016 6.66667 13.0698 6.66667 13.4061 6.44196C13.5517 6.34468 13.6767 6.21968 13.774 6.07409C13.9987 5.73779 13.9987 5.26964 13.9987 4.33333C13.9987 3.39703 13.9987 2.92887 13.774 2.59257C13.6767 2.44699 13.5517 2.32199 13.4061 2.22471C13.0698 2 12.6016 2 11.6654 2C10.729 2 10.2609 2 9.92456 2.22471C9.77903 2.32199 9.65403 2.44699 9.5567 2.59257C9.33203 2.92887 9.33203 3.39703 9.33203 4.33333C9.33203 5.26964 9.33203 5.73779 9.5567 6.07409C9.65403 6.21968 9.77903 6.34468 9.92456 6.44196Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M2.59257 13.774C2.92887 13.9987 3.39703 13.9987 4.33333 13.9987C5.26965 13.9987 5.7378 13.9987 6.0741 13.774C6.21969 13.6767 6.34469 13.5517 6.44196 13.4061C6.66667 13.0698 6.66667 12.6017 6.66667 11.6654C6.66667 10.729 6.66667 10.2609 6.44196 9.92463C6.34469 9.77903 6.21969 9.65403 6.0741 9.55676C5.7378 9.33203 5.26965 9.33203 4.33333 9.33203C3.39703 9.33203 2.92887 9.33203 2.59257 9.55676C2.44699 9.65403 2.32199 9.77903 2.22471 9.92463C2 10.2609 2 10.729 2 11.6654C2 12.6017 2 13.0698 2.22471 13.4061C2.32199 13.5517 2.44699 13.6767 2.59257 13.774Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M9.92456 13.774C10.2609 13.9987 10.729 13.9987 11.6654 13.9987C12.6016 13.9987 13.0698 13.9987 13.4061 13.774C13.5517 13.6767 13.6767 13.5517 13.774 13.4061C13.9987 13.0698 13.9987 12.6017 13.9987 11.6654C13.9987 10.729 13.9987 10.2609 13.774 9.92463C13.6767 9.77903 13.5517 9.65403 13.4061 9.55676C13.0698 9.33203 12.6016 9.33203 11.6654 9.33203C10.729 9.33203 10.2609 9.33203 9.92456 9.55676C9.77903 9.65403 9.65403 9.77903 9.5567 9.92463C9.33203 10.2609 9.33203 10.729 9.33203 11.6654C9.33203 12.6017 9.33203 13.0698 9.5567 13.4061C9.65403 13.5517 9.77903 13.6767 9.92456 13.774Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
  </svg>
);
